import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_AlertMaintenance } from "../shared/data.service";

import { wsAlertMaintenanceIncidentAlertGetDataParm } from "../shared/wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertGetDataInfo } from "../shared/wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertSoundInfo } from "../shared/wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertSeverityInfo } from "../shared/wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertPriorityInfo } from "../shared/wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertFrequencyInfo } from "../shared/wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertStationModeInfo } from "../shared/wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertAddParm } from "../shared/wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertUpdateParm } from "../shared/wsAlertMaintenanceIncidentAlertInfo";
import { wsAlertMaintenanceIncidentAlertStationModeParm } from "../shared/wsAlertMaintenanceIncidentAlertInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

@Component({
	selector: "app-root",
	templateUrl: "./addeditincidentalert.component.html",
	styleUrls: ["./addeditincidentalert.component.css"],
	providers: [ConfirmationService],
})
export class AddEditIncidentAlertComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_AlertMaintenance,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public SchoolID: number = -1;
	public AlertID: number = -1;
	public isAdd: boolean = false;
	public isViewOnly: boolean = false;
	public isLimitedEdit: boolean = false;
	public selectedGroupValue: string = "2";

	public IncidentAlertData: wsAlertMaintenanceIncidentAlertGetDataInfo;

	public lstSoundItems: wsAlertMaintenanceIncidentAlertSoundInfo[] = [];
	public SelectedSound: wsAlertMaintenanceIncidentAlertSoundInfo;

	public lstSeverityItems: wsAlertMaintenanceIncidentAlertSeverityInfo[] = [];
	public SelectedSeverity: wsAlertMaintenanceIncidentAlertSeverityInfo;

	public lstPriorityItems: wsAlertMaintenanceIncidentAlertPriorityInfo[] = [];
	public SelectedPriority: wsAlertMaintenanceIncidentAlertPriorityInfo;

	public lstFrequencyItems: wsAlertMaintenanceIncidentAlertFrequencyInfo[] = [];
	public SelectedFrequency: wsAlertMaintenanceIncidentAlertFrequencyInfo;

	public lstStationModeItems: wsAlertMaintenanceIncidentAlertStationModeInfo[] = [];
	public isSelectAll: boolean = false;

	public rAlertCD: string = "";
	public rAlertDesc: string = "";
	public rMessage: string = "";
	public rMessagecolor: string = "#ebebeb;"; // Default to match border color until loaded

	public mp3Player: any = new Audio();

	//	DataTable page counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.AlertID = this.dialogConfig.data.AlertID;
		this.isAdd = this.dialogConfig.data.isAdd;

		let parm: wsAlertMaintenanceIncidentAlertGetDataParm = {
			UserID: this.UserID,
			AlertID: this.AlertID,
			SchoolID: this.SchoolID,
		};

		this.isBusy = true;
		this.dataService.AlertMaintenanceIncidentAlertDataGet(parm).subscribe((data) => this.AlertMaintenanceIncidentAlertDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceIncidentAlertDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceIncidentAlertDataGet_Complete(data: any) {
		this.IncidentAlertData = data;

		this.lstSoundItems = this.IncidentAlertData.SoundItems;
		this.lstSeverityItems = this.IncidentAlertData.SeverityItems;
		this.lstPriorityItems = this.IncidentAlertData.PriorityItems;
		this.lstFrequencyItems = this.IncidentAlertData.FrequencyItems;
		this.lstStationModeItems = this.IncidentAlertData.StationModeItems;

		this.rAlertCD = this.IncidentAlertData.AlertCD;
		this.rAlertDesc = this.IncidentAlertData.AlertDesc;
		this.rMessage = this.IncidentAlertData.Message;
		this.rMessagecolor = this.IncidentAlertData.FontColor;

		let tmpDefinedByID = this.IncidentAlertData.DefinedByID;

		if (this.isAdd == true) {
			//
			//	Add Mode
			//
			this.selectedGroupValue = "2"; // Current School Only
			this.isViewOnly = false;
			this.isLimitedEdit = false;
		} else {
			//
			//	Edit Mode
			//
			this.isViewOnly = false;
			this.isLimitedEdit = false;

			if (this.IncidentAlertData.SchoolID < 1) {
				//
				// All Schools
				//
				this.selectedGroupValue = "1"; // All Schools

				if (this.IncidentAlertData.DefinedByID == 1 || this.IncidentAlertData.DefinedByID == 2) {
					// System or Import
					if (this.UserLevelID == 1) {
						// District Level
						this.isLimitedEdit = true;
					} else {
						this.isViewOnly = true;
					}
				}

				if (this.IncidentAlertData.DefinedByID == 3 || this.IncidentAlertData.DefinedByID == 4) {
					// School or District
					if (this.UserLevelID == 3) {
						// School Level
						this.isViewOnly = true;
					}
				}
			} else {
				//
				//	Current School Only
				//
				this.selectedGroupValue = "2"; // Current School Only

				if (this.IncidentAlertData.DefinedByID == 1 || this.IncidentAlertData.DefinedByID == 2) {
					// System or Import
					if (this.UserLevelID == 1) {
						// District Level
						this.isLimitedEdit = true;
					} else {
						this.isViewOnly = true;
					}
				}

				if (this.IncidentAlertData.DefinedByID == 4) {
					// District
					if (this.UserLevelID == 3) {
						// School Level
						this.isViewOnly = true;
					}
				}
			}
		}

		//
		//	Select Default Sound
		//
		this.SelectedSound = this.lstSoundItems[0];

		this.lstSoundItems.forEach((item) => {
			if (item.SoundLibraryID == this.IncidentAlertData.SoundLibraryID) {
				this.SelectedSound = item;
			}
		});

		//
		//	Select Default Severity
		//
		this.SelectedSeverity = this.lstSeverityItems[0];

		this.lstSeverityItems.forEach((item) => {
			if (item.AlertSeverityID == this.IncidentAlertData.AlertSeverityID) {
				this.SelectedSeverity = item;
			}
		});

		//
		//	Select Default Priority
		//
		this.SelectedPriority = this.lstPriorityItems[0];

		this.lstPriorityItems.forEach((item) => {
			if (item.PriorityID == this.IncidentAlertData.Priority) {
				this.SelectedPriority = item;
			}
		});

		//
		//	Select Default Frequency
		//
		this.SelectedFrequency = this.lstFrequencyItems[0];

		this.lstFrequencyItems.forEach((item) => {
			if (item.AlertFrequencyID == this.IncidentAlertData.AlertFrequencyID) {
				this.SelectedFrequency = item;
			}
		});

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSeverityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSeverityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPriorityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPriorityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFrequencyChange
	//
	//-----------------------------------------------------------------------------------------------------
	onFrequencyChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSoundChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSoundChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSelectAll
	//
	//-----------------------------------------------------------------------------------------------------
	onSelectAll(e: any) {
		this.lstStationModeItems.forEach((item) => {
			if (this.isSelectAll == true) {
				item.Active = true;
			} else {
				item.Active = false;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPlay
	//
	//-----------------------------------------------------------------------------------------------------
	onPlay() {
		if (this.SelectedSound.SoundFile != "(NONE)") {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedSound.SoundData);
			this.mp3Player.play();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStop
	//
	//-----------------------------------------------------------------------------------------------------
	onStop() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onAddUpdate() {
		this.ErrorMessage = "";

		//
		// Validate Message
		//

		if (this.rAlertCD.length < 1) {
			this.ErrorMessage = "Code must be entered.";
			return;
		}

		if (this.rAlertDesc.length < 1) {
			this.ErrorMessage = "Description must be entered.";
			return;
		}

		if (this.rMessage.length < 1) {
			this.ErrorMessage = "Message must be entered.";
			return;
		}

		if ((this.SelectedSeverity.AlertSeverityID == 1 || this.SelectedSeverity.AlertSeverityID == 2) && this.SelectedFrequency.AlertFrequencyID == 0) {
			this.ErrorMessage = "Frequency not valid with chosen Severity";
			return;
		}

		if (this.SelectedSeverity.AlertSeverityID == 1 && this.SelectedSound.SoundLibraryID < 1) {
			this.ErrorMessage = "Sound is required for chosen Severity";
			return;
		}

		//
		//	Validations Passed, Do the Insert or Update
		//
		if (this.AlertID < 1) {
			//
			//	INSERT
			//
			let parmDefinedByID: number;
			let parmSchoolID: number;

			if (this.selectedGroupValue == "1") {
				// All Schools
				parmDefinedByID = 4; // District User
				parmSchoolID = -1;
			} else {
				parmDefinedByID = 3; // School User
				parmSchoolID = this.SchoolID; // current school
			}

			let lstStationModes: wsAlertMaintenanceIncidentAlertStationModeParm[] = [];

			this.lstStationModeItems.forEach((item) => {
				lstStationModes.push({
					StationModeID: item.StationModeID,
					Active: item.Active,
				});
			});

			let parm: wsAlertMaintenanceIncidentAlertAddParm = {
				AlertCD: this.rAlertCD,
				AlertDesc: this.rAlertDesc,
				Message: this.rMessage,
				FontColor: this.rMessagecolor,
				AlertSeverityID: this.SelectedSeverity.AlertSeverityID,
				Priority: this.SelectedPriority.PriorityID,
				AlertFrequencyID: this.SelectedFrequency.AlertFrequencyID,
				SoundLibraryID: this.SelectedSound.SoundLibraryID,
				SchoolID: parmSchoolID,
				DefinedByID: parmDefinedByID,
				StationModeItems: lstStationModes,
			};

			this.isBusy = true;
			this.dataService.AlertMaintenanceIncidentAlertAdd(parm).subscribe((data) => this.AlertMaintenanceIncidentAlertAdd_Complete(data));
		} else {
			//
			//	UPDATE
			//
			let lstStationModes: wsAlertMaintenanceIncidentAlertStationModeParm[] = [];

			this.lstStationModeItems.forEach((item) => {
				lstStationModes.push({
					StationModeID: item.StationModeID,
					Active: item.Active,
				});
			});

			let parm: wsAlertMaintenanceIncidentAlertUpdateParm = {
				AlertID: this.AlertID,
				AlertCD: this.rAlertCD,
				AlertDesc: this.rAlertDesc,
				Message: this.rMessage,
				FontColor: this.rMessagecolor,
				AlertSeverityID: this.SelectedSeverity.AlertSeverityID,
				Priority: this.SelectedPriority.PriorityID,
				AlertFrequencyID: this.SelectedFrequency.AlertFrequencyID,
				SoundLibraryID: this.SelectedSound.SoundLibraryID,
				StationModeItems: lstStationModes,
			};

			this.isBusy = true;
			this.dataService.AlertMaintenanceIncidentAlertUpdate(parm).subscribe((data) => this.AlertMaintenanceIncidentAlertUpdate_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceIncidentAlertAdd_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceIncidentAlertAdd_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceIncidentAlertUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceIncidentAlertUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
